import { render, staticRenderFns } from "./AnalogClock.vue?vue&type=template&id=571f39b6&scoped=true&"
import script from "./AnalogClock.vue?vue&type=script&lang=js&"
export * from "./AnalogClock.vue?vue&type=script&lang=js&"
import style0 from "./AnalogClock.vue?vue&type=style&index=0&id=571f39b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f39b6",
  null
  
)

export default component.exports